import Product from "presentation/components/ProductPage";

export default function ProductPage() {
    return <Product />;
}
